import { z } from 'zod';
// =========================================================
// Mapeo Receta Blend → Producto BC (hor.mapeo_recetas).
//
// Cada planta escribe el nombre de receta a su manera en el dosificador
// (texto libre). Esta pantalla admin deja asociar ese texto, por planta,
// a un producto ensamblado real de Business Central — sin depender de que
// todas las plantas escriban el nombre exactamente igual.
// =========================================================
export const ProductoEnsambladoBCSchema = z.object({
    codigo: z.string(),
    descripcion: z.string(),
});
export const ListaProductosEnsambladosBCResponseSchema = z.object({
    productos: z.array(ProductoEnsambladoBCSchema),
});
export const RecetaBlendMapeoSchema = z.object({
    id_receta_blend: z.number(),
    nombre_texto: z.string(),
    planta_codigo: z.string(),
    codigo_bc: z.string().nullable(),
    descripcion_bc: z.string().nullable(),
});
export const ListaRecetasBlendMapeoResponseSchema = z.object({
    recetas: z.array(RecetaBlendMapeoSchema),
});
export const GuardarMapeoRecetaRequestSchema = z.object({
    id_receta_blend: z.number().int().positive(),
    codigo_bc: z.string().trim().min(1).max(20),
    descripcion_bc: z.string().trim().min(1).max(100),
});
//# sourceMappingURL=mapeo-recetas.js.map